module.exports = __webpack_public_path__ + "img/invest_list4.60d59e26.png";